/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Form from "../../../shared/forms/Form";
import Field from "../../../shared/forms/Field";
import FormTextBox from "../../../shared/forms/FormFields/FormTextBox";
import ExGrid from "../../../shared/Grid/ExGrid";
import ExColumn from "../../../shared/Grid/ExColumn";
import AddButton from "../../../shared/Grid/Buttons/AddButton";
import DeleteButton from "../../../shared/Grid/Buttons/DeleteButton";
import FormInputFile from "../../../shared/forms/FormFields/FormInputFile"
import useApiIncidencia from "../../../api/administracion/useApiIncidencia";
import alerts from "../../../shared/alerts";
const Documentos = ({ value, onChange }) => {
    const api = useApiIncidencia();
    const quitarDocumento = async (documentoId, eliminarDoc) => {
        if ((await alerts.preguntarSiNo("¿Desea eliminar el documento de la incidencia?")) === true) {
            eliminarDoc();
            await api.quitarDocumentoIncidencia(value?.id,documentoId);
        }
    };
    return (
        <Form values={value} onChange={onChange}>
            <Field field={"documentosIncidencias"} cols={4} 
                render={({ value, onParentChange, ...props }) => (
                    <ExGrid 
                        {...props} 
                        data={value}
                        onChange={(data) => onParentChange({ documentosIncidencias: data })}
                        getEntityId={(row) => row._uniqueUid}
                    >
                        <ExColumn 
                            field="nombreDocumento" 
                            title="Nombre del documento" 
                            required={true}
                            cellRenderer={({ row, ...props }) => 
                                <FormTextBox disabled={false} style={{ width: '100%' }} {...props} />
                            }
                        />
                        <ExColumn 
                            field="archivo" 
                            title="Archivo" 
                            required={true} 
                            cellRenderer={({ row, ...props }) => 
                                <FormInputFile disabled={false} style={{ width: '100%' }} {...props} />
                            }
                        />
                        <ExColumn 
                            field={"command"}
                            headerRenderer={({ onAdd }) => <AddButton onAdd={onAdd} />}
                            cellRenderer={({ row, onDelete }) => 
                                <DeleteButton onDelete={() => quitarDocumento(row.documentoId, onDelete)} />
                            }
                            width={'50px'} 
                        />
                    </ExGrid>
                )}
            />
        </Form>
    );
};
export default Documentos;
